import { BbkExpressionElement } from './components/BbkExpressionElement';
import { GetRenderElementOptions } from '@udecode/slate-plugins';

export const ELEMENT_BBK_EXPRESSION = 'bbk-expression';

export const DEFAULTS_BBK_EXPRESSION: {
  bbkExpression: GetRenderElementOptions;
} = {
  bbkExpression: {
    component: BbkExpressionElement,
    type: ELEMENT_BBK_EXPRESSION,
    rootProps: {
      className: 'slate-bbk-expression',
      // prefix: '@',
    },
    hotkey: '',
    defaultType: '',
  },
};
